import "./StockSetupApprove.css";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import moment, { max } from "moment";
import {
  Button,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  CmpDatePickerField001V1,
  CmpSelectFieldV1,
} from "../../Component/Common/ToolBox/ToolBoxV1";
import GCAutocompleteCheckboxFixSizeUid from "../StockSetupApprove/GCAutocompleteCheckboxFixSizeUid";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import {
  AttributesStockSetup,
  ItemsSetupAudit001_GetRow,
  Update_ItemsSetup_From_Audit,
} from "../../Server/ApiV2";
import { vRdxUserInfo } from "../../Redux/roStore";
import GCAutocompleteCheckboxFixSizeCd from "./GCAutocompleteCheckboxFixSizeCd";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";

const StockSetupApprove = () => {
  const apiRef = useGridApiRef();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const vMediaQuery = useMediaQuery("(max-width: 1000px)");

  const [row, setRow] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [Location, setLocation] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [Verify, setVerify] = useState([]);

  const [isEditing, setIsEditing] = useState(false);
  const [editedFieldsMap, setEditedFieldsMap] = useState({});
  const [originalRowData, setOriginalRowData] = useState([]);

  const formData = {
    fromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    toDate: new Date(),
    location: [],
    department: [],
    verify: "B",
  };
  console.log("selectedRows : ", selectedRows);

  const [masterData, setMasterData] = useState(formData);

  const fetchStockSetupAttributes = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();

    var obj = {
      v_UserCd: vRdxUserInfoObj?.UserID || "",
    };

    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const AttributeRes = await AttributesStockSetup(FinalObj);

    if (AttributeRes?.status === 200) {
      setLocation(AttributeRes?.data?.ResultSet?.Location || []);
      setDepartment(AttributeRes?.data?.ResultSet?.Document || []);
      setVerify(AttributeRes?.data?.ResultSet?.iVerify || []);
      let loc = [AttributeRes?.data?.ResultSet?.Location[0]?.UID] || [];
      // let Dept = [AttributeRes?.data?.ResultSet?.Document[0]?.Cd] || [];
      let verify = AttributeRes?.data?.ResultSet?.iVerify[2]?.Uid || "";

      setMasterData((prev) => ({
        ...prev,
        location: loc,
        // department: Dept,
        verify: verify,
      }));
      handleLoadBtn(
        masterData?.fromDate,
        masterData?.toDate,
        loc,
        verify
        // Dept
      );
    }
  };

  const allDepartmentCodes = Department.map((item) => item.Cd);
  useEffect(() => {
    if (Department?.length > 0) {
      setMasterData((prev) => ({ ...prev, department: allDepartmentCodes }));
    }
  }, [Department]);

  useEffect(() => {
    fetchStockSetupAttributes();
  }, []);

  const fValidationHead = () => {
    let isValid = true;

    if (masterData?.fromDate == null) {
      fAlertToast("INFO", "Date1 should not be empty");
      return;
    }

    if (masterData?.toDate == null) {
      fAlertToast("INFO", "Date2 should not be empty");
      return;
    }

    if (masterData?.verify == "") {
      fAlertToast("INFO", "To Date should not be empty");
      return;
    }

    if (masterData?.department.length == 0) {
      fAlertToast("INFO", "Department should not be empty");
      return;
    }

    if (masterData?.location.length == 0) {
      fAlertToast("INFO", "Location should not be empty");
      return;
    }

    return isValid;
  };

  const handleLoadBtn = async (
    date1 = masterData?.fromDate,
    date2 = masterData?.toDate,
    location = masterData?.location,
    verify = masterData?.verify,
    formattedDept = masterData?.department
  ) => {
    setBulkEdit({
      Apr_MinStockDays: "",
      Apr_SafetyStockDays: "",
      Apr_MaxShelfQty: "",
      Apr_MinShelfQty: "",
    });
    // const isHeadValid = fValidationHead();
    // if (!isHeadValid) return;

    var obj = {
      Location: location.join(","),
      VerifiedFlag: verify,
      Date1: moment(date1).format("MM/DD/YYYY"),
      Date2: moment(date2).format("MM/DD/YYYY"),
      Department: formattedDept.join(","),
    };

    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const StockResponse = await ItemsSetupAudit001_GetRow(FinalObj);
    if (StockResponse?.status === 200) {
      setRow(StockResponse?.data?.ResultSet);
      setOriginalRowData(StockResponse?.data?.ResultSet);
    }
  };

  const fValidationDetail = () => {
    let isValid = true;

    for (const item of selectedRows || []) {
      if (item.ID === "" || item.ID === undefined || item.ID === null) {
        fAlertToast("INFO", "ID is required.");
        isValid = false;
        break;
      }

      if (
        item.ItmCd === "" ||
        item.ItmCd === undefined ||
        item.ItmCd === null
      ) {
        fAlertToast("INFO", "Item Code is required.");
        isValid = false;
        break;
      }

      if (item.Loc === "" || item.Loc === undefined || item.Loc === null) {
        fAlertToast("INFO", "Location is required.");
        isValid = false;
        break;
      }

      if (
        item.Old_MinStockDays === "" ||
        item.Old_MinStockDays === undefined ||
        item.Old_MinStockDays === null
      ) {
        fAlertToast("INFO", "Old_MinStockDays is required.");
        isValid = false;
        break;
      }

      if (
        item.New_MinStockDays === "" ||
        item.New_MinStockDays === undefined ||
        item.New_MinStockDays === null
      ) {
        fAlertToast("INFO", "New_MinStockDays is required.");
        isValid = false;
        break;
      }

      if (
        item.Old_SafetyStockDays === "" ||
        item.Old_SafetyStockDays === undefined ||
        item.Old_SafetyStockDays === null
      ) {
        fAlertToast("INFO", "Old_SafetyStockDays is required.");
        isValid = false;
        break;
      }

      if (
        item.New_SafetyStockDays === "" ||
        item.New_SafetyStockDays === undefined ||
        item.New_SafetyStockDays === null
      ) {
        fAlertToast("INFO", "New_SafetyStockDays is required.");
        isValid = false;
        break;
      }

      if (
        item.Old_MaxStockDays === "" ||
        item.Old_MaxStockDays === undefined ||
        item.Old_MaxStockDays === null
      ) {
        fAlertToast("INFO", "Old_MaxStockDays is required.");
        isValid = false;
        break;
      }

      if (
        item.New_MaxStockDays === "" ||
        item.New_MaxStockDays === undefined ||
        item.New_MaxStockDays === null
      ) {
        fAlertToast("INFO", "New_MaxStockDays is required.");
        isValid = false;
        break;
      }

      if (
        item.Old_MaxShelfQty === "" ||
        item.Old_MaxShelfQty === undefined ||
        item.Old_MaxShelfQty === null
      ) {
        fAlertToast("INFO", "Old_MaxShelfQty is required.");
        isValid = false;
        break;
      }

      if (
        item.New_MaxShelfQty === "" ||
        item.New_MaxShelfQty === undefined ||
        item.New_MaxShelfQty === null
      ) {
        fAlertToast("INFO", "New_MaxShelfQty is required.");
        isValid = false;
        break;
      }

      if (
        item.Old_MinShelfQty === "" ||
        item.Old_MinShelfQty === undefined ||
        item.Old_MinShelfQty === null
      ) {
        fAlertToast("INFO", "Old_MinShelfQty is required.");
        isValid = false;
        break;
      }

      if (
        item.New_MinShelfQty === "" ||
        item.New_MinShelfQty === undefined ||
        item.New_MinShelfQty === null
      ) {
        fAlertToast("INFO", "New_MinShelfQty is required.");
        isValid = false;
        break;
      }

      if (
        item.Apr_SafetyStockDays === "" ||
        item.Apr_SafetyStockDays === undefined ||
        item.Apr_SafetyStockDays === null
      ) {
        fAlertToast("INFO", "Approved SafetyStockDays is required.");
        isValid = false;
        break;
      }

      if (
        item.Apr_MaxStockDays === "" ||
        item.Apr_MaxStockDays === undefined ||
        item.Apr_MaxStockDays === null
      ) {
        fAlertToast("INFO", "Approved MaxStockDays is required.");
        isValid = false;
        break;
      }

      if (
        item.Apr_MaxShelfQty === "" ||
        item.Apr_MaxShelfQty === undefined ||
        item.Apr_MaxShelfQty === null
      ) {
        fAlertToast("INFO", "Approved MaxShelfQty is required.");
        isValid = false;
        break;
      }

      if (
        item.Apr_MinShelfQty === "" ||
        item.Apr_MinShelfQty === undefined ||
        item.Apr_MinShelfQty === null
      ) {
        fAlertToast("INFO", "Approved MinShelfQty is required.");
        isValid = false;
        break;
      }

      if (
        item.Apr_MinStockDays === "" ||
        item.Apr_MinStockDays === undefined ||
        item.Apr_MinStockDays === null
      ) {
        fAlertToast("INFO", "Approved MinStockDays is required.");
        isValid = false;
        break;
      }
    }

    return isValid;
  };

  const handleSaveBtn = async () => {
    // ID, ItmCd, Location, FieldName, ApprovedValue

    if (selectedRows.length == 0) {
      fAlertToast("FAILED", "LineItems should not be empty");
      return;
    }

    if (!fValidationDetail()) return;

    const invalidItem = selectedRows.find(
      (item) => item.Approved == 0 || item.Approved == ""
    );

    if (invalidItem) {
      fAlertToast("FAILED", "Approved should not be empty or zero");
      return;
    }

    const vRdxUserInfoObj = vRdxUserInfo();

    const items = selectedRows?.map((item) => ({
      ID: item.ID || "",
      ItmCd: item.ItmCd || "",
      Location: item.Loc || "",
      Old_MinStockDays: item.Old_MinStockDays,
      New_MinStockDays: item.New_MinStockDays,
      Old_SafetyStockDays: item.Old_SafetyStockDays,
      New_SafetyStockDays: item.New_SafetyStockDays,
      Old_MaxStockDays: item.Old_MaxStockDays,
      New_MaxStockDays: item.New_MaxStockDays,
      Old_MaxShelfQty: item.Old_MaxShelfQty,
      New_MaxShelfQty: item.New_MaxShelfQty,
      Old_MinShelfQty: item.Old_MinShelfQty,
      New_MinShelfQty: item.New_MinShelfQty,
      Apr_SafetyStockDays: item.Apr_SafetyStockDays,
      Apr_MaxStockDays: item.Apr_MaxStockDays,
      Apr_MaxShelfQty: item.Apr_MaxShelfQty,
      Apr_MinShelfQty: item.Apr_MinShelfQty,
      Apr_MinStockDays: item.Apr_MinStockDays,
      ApBy: vRdxUserInfoObj?.UserID,
    }));

    if (items.length == 0) {
      fAlertToast("INFO", "LineItem should not be empty");
      return;
    }

    var obj = {
      LineItems: items,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const StockResponse = await Update_ItemsSetup_From_Audit(FinalObj);
    if (StockResponse?.status === 200) {
      fAlertToast("SUCCESS", "Saved Successfully");
      setSelectedRows([]);
      setRow([]);
      setBulkEdit({
        Apr_MinStockDays: "",
        Apr_SafetyStockDays: "",
        Apr_MaxShelfQty: "",
        Apr_MinShelfQty: "",
      });
      handleLoadBtn();
    }
  };

  const handleClearBtn = () => {
    setRow([]);
    setSelectedRows([]);
    let loc = [Location[0]?.UID] || [];
    // let Dept = [Department[0]?.Cd] || [];
    let verify = Verify[2]?.Uid || "";
    setMasterData((prev) => ({ ...prev, department: allDepartmentCodes }));
    setMasterData((pre) => ({
      ...pre,
      location: loc,
      // department: Dept,
      verify: verify,
    }));
    setBulkEdit({
      Apr_MinStockDays: "",
      Apr_SafetyStockDays: "",
      Apr_MaxShelfQty: "",
      Apr_MinShelfQty: "",
    });
    // handleLoadBtn(formData?.fromDate, formData?.toDate, loc, verify, Dept);
    handleLoadBtn(formData?.fromDate, formData?.toDate, loc, verify);
  };

  const handleFieldEdit = (params, value, fieldName, parser = (v) => v) => {
    const currentRowIndex = row.findIndex((r) => r.ID === params.row.ID);
    const originalRow = originalRowData.find((r) => r.ID === params.row.ID);

    const updatedRow = {
      ...row[currentRowIndex],
      [fieldName]: parser(value),
    };

    if (
      fieldName === "Apr_MinStockDays" ||
      fieldName === "Apr_SafetyStockDays"
    ) {
      const minVal =
        fieldName === "Apr_MinStockDays"
          ? parser(value)
          : updatedRow.Apr_MinStockDays;
      const safetyVal =
        fieldName === "Apr_SafetyStockDays"
          ? parser(value)
          : updatedRow.Apr_SafetyStockDays;

      const min = isNaN(minVal) ? 0 : minVal;
      const safety = isNaN(safetyVal) ? 0 : safetyVal;

      updatedRow.Apr_MaxStockDays = min + safety;
    }

    const newRowData = [...row];
    newRowData[currentRowIndex] = updatedRow;
    setRow(newRowData);

    setEditedFieldsMap((prev) => ({
      ...prev,
      [params.row.ID]: {
        ...(prev[params.row.ID] || {}),
        [fieldName]: true,
      },
    }));

    let updatedSelectedRows = [...selectedRows];
    const rowExistsIndex = updatedSelectedRows.findIndex(
      (r) => r.ID === updatedRow.ID
    );

    const fieldsToCompare = [
      "Apr_MinStockDays",
      "Apr_SafetyStockDays",
      "Apr_MaxStockDays",
      "Apr_MaxShelfQty",
      "Apr_MinShelfQty",
    ];

    const isDifferent = fieldsToCompare.some(
      (field) => updatedRow[field] !== originalRow[field]
    );

    if (isDifferent) {
      if (rowExistsIndex === -1) {
        updatedSelectedRows.push(updatedRow);
      } else {
        updatedSelectedRows[rowExistsIndex] = updatedRow;
      }
    } else {
      if (rowExistsIndex !== -1) {
        updatedSelectedRows.splice(rowExistsIndex, 1);
      }
    }

    setSelectedRows(updatedSelectedRows);
    return updatedRow;
  };

  const handleSelectionChange = (selectedIds) => {
    if (!row || row.length === 0) return;

    let updatedDetails = [...row];
    let updatedSelectedRows = [];

    updatedDetails = updatedDetails.map((row) => {
      if (selectedIds.includes(row.ID)) {
        updatedSelectedRows.push({
          ID: row.ID,
          ItmCd: row.ItmCd,
          Loc: row.Loc,
          Apr_MinStockDays: row.Apr_MinStockDays,
          Apr_SafetyStockDays: row.Apr_SafetyStockDays,
          Apr_MaxStockDays: row.Apr_MaxStockDays,
          Apr_MaxShelfQty: row.Apr_MaxShelfQty,
          Apr_MinShelfQty: row.Apr_MinShelfQty,
          Old_MinStockDays: row.Old_MinStockDays,
          New_MinStockDays: row.New_MinStockDays,
          Old_SafetyStockDays: row.Old_SafetyStockDays,
          New_SafetyStockDays: row.New_SafetyStockDays,
          Old_MaxStockDays: row.Old_MaxStockDays,
          New_MaxStockDays: row.New_MaxStockDays,
          Old_MaxShelfQty: row.Old_MaxShelfQty,
          New_MaxShelfQty: row.New_MaxShelfQty,
          Old_MinShelfQty: row.Old_MinShelfQty,
          New_MinShelfQty: row.New_MinShelfQty,
        });

        return {
          ...row,
          Apr_MinStockDays: row.Apr_MinStockDays,
          Apr_SafetyStockDays: row.Apr_SafetyStockDays,
          Apr_MaxStockDays: row.Apr_MaxStockDays,
          Apr_MaxShelfQty: row.Apr_MaxShelfQty,
          Apr_MinShelfQty: row.Apr_MinShelfQty,
        };
      } else {
        return {
          ...row,
          Apr_MinStockDays: row.Apr_MinStockDays,
          Apr_SafetyStockDays: row.Apr_SafetyStockDays,
          Apr_MaxStockDays: row.Apr_MaxStockDays,
          Apr_MaxShelfQty: row.Apr_MaxShelfQty,
          Apr_MinShelfQty: row.Apr_MinShelfQty,
        };
      }
    });

    setRow(updatedDetails);
    setSelectedRows(updatedSelectedRows);
  };

  const [bulkEdit, setBulkEdit] = useState({
    Apr_MinStockDays: "",
    Apr_SafetyStockDays: "",
    Apr_MaxShelfQty: "",
    Apr_MinShelfQty: "",
  });

  const handleBulkEditChange = (field, value) => {
    const updatedValue = value === "" ? "" : parseInt(value, 10);

    setBulkEdit((prev) => ({
      ...prev,
      [field]: value,
    }));

    const updatedRows = row.map((r) => {
      const oldField = field.replace("Apr_", "Old_");
      const newField = field.replace("Apr_", "New_");

      const shouldUpdate = r[oldField] !== r[newField];

      const newMinStockDays =
        field === "Apr_MinStockDays"
          ? updatedValue === ""
            ? parseInt(r.New_MinStockDays || 0, 10)
            : updatedValue
          : parseInt(bulkEdit.Apr_MinStockDays || r.New_MinStockDays || 0, 10);

      const newSafetyStockDays =
        field === "Apr_SafetyStockDays"
          ? updatedValue === ""
            ? parseInt(r.New_SafetyStockDays || 0, 10)
            : updatedValue
          : parseInt(
              bulkEdit.Apr_SafetyStockDays || r.New_SafetyStockDays || 0,
              10
            );

      return {
        ...r,
        [field]:
          value === "" ? r[newField] : shouldUpdate ? updatedValue : r[field],
        ...(field === "Apr_MinStockDays" || field === "Apr_SafetyStockDays"
          ? {
              Apr_MaxStockDays:
                (isNaN(newMinStockDays) ? 0 : newMinStockDays) +
                (isNaN(newSafetyStockDays) ? 0 : newSafetyStockDays),
            }
          : {}),
      };
    });

    setRow(updatedRows);

    // Update selected rows logic (optional)
    const newSelected = updatedRows.filter((r, i) =>
      [
        "Apr_MinStockDays",
        "Apr_SafetyStockDays",
        "Apr_MaxShelfQty",
        "Apr_MinShelfQty",
      ].some((k) => r[k] !== originalRowData[i][k])
    );
    setSelectedRows(newSelected);
  };

  const columnGroupingModel = [
    {
      groupId: "Min.Stock Days",
      children: [
        { field: "Old_MinStockDays" },
        { field: "New_MinStockDays" },
        { field: "Apr_MinStockDays" },
      ],
    },
    {
      groupId: "Safety Stock Days",
      children: [
        { field: "Old_SafetyStockDays" },
        { field: "New_SafetyStockDays" },
        { field: "Apr_SafetyStockDays" },
      ],
    },
    {
      groupId: "Max.Stock Days",
      children: [
        { field: "Old_MaxStockDays" },
        { field: "New_MaxStockDays" },
        { field: "Apr_MaxStockDays" },
      ],
    },
    {
      groupId: "Max.Shelf Qty",
      children: [
        { field: "Old_MaxShelfQty" },
        { field: "New_MaxShelfQty" },
        { field: "Apr_MaxShelfQty" },
      ],
    },
    {
      groupId: "Min.Shelf Qty",
      children: [
        { field: "Old_MinShelfQty" },
        { field: "New_MinShelfQty" },
        { field: "Apr_MinShelfQty" },
      ],
    },
  ];

  const getOldCellClass = (oldValue, newValue) =>
    oldValue !== newValue ? "cell-old" : "";
  const getNewCellClass = (oldValue, newValue) =>
    oldValue !== newValue ? "cell-new" : "";
  const getApproveCellClass = (oldValue, newValue) =>
    oldValue !== newValue ? "cell-approve" : "";

     const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true
    });
    };
    const handlePrint = () => {
      apiRef.current.exportDataAsPrint();
    };

  return (
    <>
    <div className="div-container">
      <div className="mt-4 mb-3 ">
        <span className="breadcrumb-not-active">Stock Setup Approve</span>
      </div>
      <Grid container spacing={{xs:0.5,sm:1}}>
        <Grid item xs={6} sm={2.5} md={2} lg={1.5}>
          <Typography>From Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName={"fromDate"}
            xValue={masterData?.fromDate}
            xOnChange={(event) => {
              if (
                event?.$d == "Invalid Date" ||
                event?.$d == null ||
                event?.$d === undefined ||
                event?.$d === ""
              ) {
                setMasterData((obj) => ({
                  ...obj,
                  fromDate: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1
                  ),
                }));
              } else {
                setMasterData((obj) => ({
                  ...obj,
                  fromDate: event.$d,
                }));
              }
            }}
          />
        </Grid>
        <Grid item xs={6} sm={2.5} md={2} lg={1.5}>
          <Typography>To Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName={"toDate"}
            xValue={masterData?.toDate}
            xOnChange={(event) => {
              if (
                event?.$d == "Invalid Date" ||
                event?.$d == null ||
                event?.$d === undefined ||
                event?.$d === ""
              ) {
                setMasterData((obj) => ({
                  ...obj,
                  toDate: new Date(),
                }));
              } else {
                setMasterData((obj) => ({
                  ...obj,
                  toDate: event.$d,
                }));
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={7} md={4} lg={3.5}>
          <Typography>Location</Typography>
          <GCAutocompleteCheckboxFixSizeUid
            options={Location}
            xValue={masterData.location}
            // xtabIndex={"04"}
            setValue={setMasterData}
            objName="location"
            label=""
            placeholder="Search Location"
          />
        </Grid>
        <Grid item xs={12} sm={5} md={4} lg={4}>
          <Typography>Department</Typography>
          <GCAutocompleteCheckboxFixSizeCd
            options={Department}
            xValue={masterData.department}
            // key={Department?.Uid}
            // xtabIndex={"04"}
            setValue={setMasterData}
            objName="department"
            label=""
            placeholder="Search Department"
          />
        </Grid>
        <Grid item xs={8} sm={3} md={1.5} lg={1.5}>
          <Typography>Verify</Typography>
          <CmpSelectFieldV1
            xValue={masterData?.verify}
            // xLabelText={verify?.Name}
            xData={Verify}
            xName={"verify"}
            xOnChange={(e) => {
              setMasterData((prevV) => ({
                ...prevV,
                verify: e.target.value,
              }));
            }}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1.55}>
          <Typography>Min Stock Days</Typography>
          <TextField
            fullWidth
            type="number"
            size="small"
            value={bulkEdit?.Apr_MinStockDays}
            onChange={(e) =>
              handleBulkEditChange("Apr_MinStockDays", e.target.value)
            }
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1.75}>
          <Typography>Safety Stock Days</Typography>
          <TextField
            fullWidth
            type="number"
            size="small"
            value={bulkEdit?.Apr_SafetyStockDays}
            onChange={(e) =>
              handleBulkEditChange("Apr_SafetyStockDays", e.target.value)
            }
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1.5}>
          <Typography>Max Shelf Qty</Typography>
          <TextField
            fullWidth
            type="number"
            size="small"
            value={bulkEdit?.Apr_MaxShelfQty}
            onChange={(e) =>
              handleBulkEditChange("Apr_MaxShelfQty", e.target.value)
            }
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1.4}>
          <Typography sx={{ margin: "1px" }}>Min Shelf Qty</Typography>
          <TextField
            fullWidth
            type="number"
            size="small"
            value={bulkEdit?.Apr_MinShelfQty}
            onChange={(e) =>
              handleBulkEditChange("Apr_MinShelfQty", e.target.value)
            }
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          md={4.3}
          lg={5.8}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <Box display="flex" flexWrap="wrap" justifyContent={"flex-end"} gap={{xs:0.5,lg:1}}>
            <Button
              size="small"
              variant="contained"
              onClick={(e) => {
                setRow([]);
                setSelectedRows([]);
                handleLoadBtn();
              }}
            >
              Load
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={handleSaveBtn}
              disabled={isEditing}
            >
              Save
            </Button>
            <Button size="small" variant="contained" onClick={handleClearBtn}>
              Clear
            </Button>
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ height: {xs:"44vh",sm:"61vh",md:"69vh"}}} mt={0.5}>
        <DataGridPro
          apiRef={apiRef}
          rows={row}
          columns={[
            {
              field: "ID",
              headerName: "ID",
              width: vMediaQuery ? 75 : 75,
              hide: true,
              align: "center",
              type: "number",
            },
            {
              field: "ItmCd",
              headerName: "Item Code",
              width: 100,
              align: "center",
              type: "number",
            },
            {
              field: "ItmName",
              headerName: "Item Name",
              width: vMediaQuery ? 220 : 200,
              renderCell: (params) => (
                <div
                  style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    lineHeight: "1.4em",
                  }}
                >
                  {params.value}
                </div>
              ),
            },
            {
              field: "LocName",
              headerName: "Location",
              width: vMediaQuery ? 100 : 100,
              align: "center",
            },
            {
              field: "IsNew",
              headerName: "IsNew",
              width: 70,
              align: "center",
            },
            {
              field: "Old_MinStockDays",
              headerName: "Old",
              width: 40,
              align: "center",
              type: "number",
              cellClassName: (params) =>
                getOldCellClass(
                  params.row.Old_MinStockDays,
                  params.row.New_MinStockDays
                ),
            },
            {
              field: "New_MinStockDays",
              headerName: "New",
              width: 40,
              align: "center",
              type: "number",
              cellClassName: (params) =>
                getNewCellClass(
                  params.row.Old_MinStockDays,
                  params.row.New_MinStockDays
                ),
            },
            {
              field: "Apr_MinStockDays",
              headerName: "Apr",
              width: 56,
              type: "number",
              // cellClassName: (params) => getApproveCellClass(params.row.New_MinStockDays,params.row.Apr_MinStockDays),
              renderCell: (params) => (
                <TextField
                  type="number"
                  value={params.value}
                  sx={{
                    backgroundColor:
                      params.row.Old_MinStockDays !==
                      params.row.New_MinStockDays
                        ? "#C8B6FF"
                        : "",
                  }}
                  onChange={(e) =>
                    handleFieldEdit(
                      params,
                      e.target.value,
                      "Apr_MinStockDays",
                      parseInt
                    )
                  }
                  onBlur={() => setIsEditing(false)}
                  onFocus={() => setIsEditing(true)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const currentRowIndex = row.findIndex(
                        (row) => row.ItmCd === params.row.ItmCd
                      );
                      const nextRow = row[currentRowIndex + 1];
                      if (nextRow) {
                        const nextInput = document.querySelector(
                          `input[name="Apr_MinStockDays-${nextRow.ItmCd}"]`
                        );
                        if (nextInput) nextInput.focus();
                      }
                    }
                  }}
                  inputProps={{
                    name: `Apr_MinStockDays-${params.row.ItmCd}`,
                  }}
                  InputProps={{
                    sx: {
                      input: {
                        textAlign: "center", // ✅ centers the number inside
                      },
                    },
                  }}
                />
              ),
            },
            {
              field: "Old_SafetyStockDays",
              headerName: "Old ",
              width: 40,
              align: "center",
              type: "number",
              cellClassName: (params) =>
                getOldCellClass(
                  params.row.Old_SafetyStockDays,
                  params.row.New_SafetyStockDays
                ),
            },
            {
              field: "New_SafetyStockDays",
              headerName: "New",
              width: 40,
              align: "center",
              type: "number",
              cellClassName: (params) =>
                getNewCellClass(
                  params.row.Old_SafetyStockDays,
                  params.row.New_SafetyStockDays
                ),
            },
            {
              field: "Apr_SafetyStockDays",
              headerName: "Apr",
              width: 56,
              type: "number",
              renderCell: (params) => (
                <TextField
                  type="number"
                  value={params.value}
                  sx={{
                    backgroundColor:
                      params.row.Old_SafetyStockDays !==
                      params.row.New_SafetyStockDays
                        ? "#C8B6FF"
                        : "",
                  }}
                  onChange={(e) =>
                    handleFieldEdit(
                      params,
                      e.target.value,
                      "Apr_SafetyStockDays",
                      parseInt
                    )
                  }
                  onBlur={() => setIsEditing(false)}
                  onFocus={() => setIsEditing(true)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const currentRowIndex = row.findIndex(
                        (row) => row.ItmCd === params.row.ItmCd
                      );
                      const nextRow = row[currentRowIndex + 1];
                      if (nextRow) {
                        const nextInput = document.querySelector(
                          `input[name="Apr_SafetyStockDays-${nextRow.ItmCd}"]`
                        );
                        if (nextInput) nextInput.focus();
                      }
                    }
                  }}
                  inputProps={{
                    name: `Apr_SafetyStockDays-${params.row.ItmCd}`,
                  }}
                  InputProps={{
                    sx: {
                      input: {
                        textAlign: "center", // ✅ centers the number inside
                      },
                    },
                  }}
                />
              ),
            },
            {
              field: "Old_MaxStockDays",
              headerName: "Old",
              width: 40,
              align: "center",
              type: "number",
              cellClassName: (params) =>
                getOldCellClass(
                  params.row.Old_MaxStockDays,
                  params.row.New_MaxStockDays
                ),
            },
            {
              field: "New_MaxStockDays",
              headerName: "New",
              width: 40,
              align: "center",
              type: "number",
              cellClassName: (params) =>
                getNewCellClass(
                  params.row.Old_MaxStockDays,
                  params.row.New_MaxStockDays
                ),
            },
            {
              field: "Apr_MaxStockDays",
              headerName: "Apr",
              width: 56,
              align: "center",
              type: "number",
              cellClassName: (params) =>
                getApproveCellClass(
                  params.row.Old_MaxStockDays,
                  params.row.New_MaxStockDays
                ),
            },
            {
              field: "Old_MaxShelfQty",
              headerName: "Old",
              width: 40,
              align: "center",
              type: "number",
              cellClassName: (params) =>
                getOldCellClass(
                  params.row.Old_MaxShelfQty,
                  params.row.New_MaxShelfQty
                ),
            },
            {
              field: "New_MaxShelfQty",
              headerName: "New",
              width: 40,
              align: "center",
              type: "number",
              cellClassName: (params) =>
                getNewCellClass(
                  params.row.Old_MaxShelfQty,
                  params.row.New_MaxShelfQty
                ),
            },
            {
              field: "Apr_MaxShelfQty",
              headerName: "Apr",
              width: 56,
              type: "number",
              renderCell: (params) => (
                <TextField
                  type="number"
                  value={params.value}
                  sx={{
                    backgroundColor:
                      params.row.Old_MaxShelfQty !== params.row.New_MaxShelfQty
                        ? "#C8B6FF"
                        : "",
                  }}
                  onChange={(e) =>
                    handleFieldEdit(
                      params,
                      e.target.value,
                      "Apr_MaxShelfQty",
                      parseInt
                    )
                  }
                  onBlur={() => setIsEditing(false)}
                  onFocus={() => setIsEditing(true)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const currentRowIndex = row.findIndex(
                        (row) => row.ItmCd === params.row.ItmCd
                      );
                      const nextRow = row[currentRowIndex + 1];
                      if (nextRow) {
                        const nextInput = document.querySelector(
                          `input[name="Apr_MaxShelfQty-${nextRow.ItmCd}"]`
                        );
                        if (nextInput) nextInput.focus();
                      }
                    }
                  }}
                  inputProps={{
                    name: `Apr_MaxShelfQty-${params.row.ItmCd}`,
                  }}
                  InputProps={{
                    sx: {
                      input: {
                        textAlign: "center", // ✅ centers the number inside
                      },
                    },
                  }}
                />
              ),
            },
            {
              field: "Old_MinShelfQty",
              headerName: "Old",
              width: 40,
              align: "center",
              type: "number",
              cellClassName: (params) =>
                getOldCellClass(
                  params.row.Old_MinShelfQty,
                  params.row.New_MinShelfQty
                ),
            },
            {
              field: "New_MinShelfQty",
              headerName: "New",
              width: 40,
              align: "center",
              type: "number",
              cellClassName: (params) =>
                getNewCellClass(
                  params.row.Old_MinShelfQty,
                  params.row.New_MinShelfQty
                ),
            },
            {
              field: "Apr_MinShelfQty",
              headerName: "Apr",
              width: 56,
              type: "number",
              renderCell: (params) => (
                <TextField
                  type="number"
                  value={params.value}
                  sx={{
                    backgroundColor:
                      params.row.Old_MinShelfQty !== params.row.New_MinShelfQty
                        ? "#C8B6FF"
                        : "",
                  }}
                  onChange={(e) =>
                    handleFieldEdit(
                      params,
                      e.target.value,
                      "Apr_MinShelfQty",
                      parseInt
                    )
                  }
                  onBlur={() => setIsEditing(false)}
                  onFocus={() => setIsEditing(true)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const currentRowIndex = row.findIndex(
                        (row) => row.ItmCd === params.row.ItmCd
                      );
                      const nextRow = row[currentRowIndex + 1];
                      if (nextRow) {
                        const nextInput = document.querySelector(
                          `input[name="Apr_MinShelfQty-${nextRow.ItmCd}"]`
                        );
                        if (nextInput) nextInput.focus();
                      }
                    }
                  }}
                  inputProps={{
                    name: `Apr_MinShelfQty-${params.row.ItmCd}`,
                  }}
                  InputProps={{
                    sx: {
                      input: {
                        textAlign: "center", // ✅ centers the number inside
                      },
                    },
                  }}
                />
              ),
            },
            {
              field: "Department",
              headerName: "Department",
              width: vMediaQuery ? 200 : 150,
              align: "center",
            },
            {
              field: "UserName",
              headerName: "UserName",
              width: vMediaQuery ? 150 : 150,
              align: "center",
            },
            {
              field: "Date",
              headerName: "Date",
              width: vMediaQuery ? 90 : 100,
              valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
              align: "center",
            },
            {
              field: "Verified",
              headerName: "Verified",
              width: vMediaQuery ? 90 : 100,
              align: "center",
            },
          ]}
          checkboxSelection
          getRowId={(row) => row.ID}
          rowHeight={35}
          headerHeight={40}
          columnGroupingModel={columnGroupingModel}
          experimentalFeatures={{ columnGrouping: true }}
          onSelectionModelChange={(selectedIds) =>
            handleSelectionChange(selectedIds)
          }
          selectionModel={selectedRows.map((row) => row.ID)}
          hideFooter={true}
          disableSelectionOnClick
          onCellEditStart={() => setIsEditing(true)}
          onCellEditStop={() => {
            setIsEditing(false);
          }}
          onCellEditCommit={() => setIsEditing(false)}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
              color: "#24292e",
            },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked":
              {
                color: "#0298f5",
              },
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
            "& .MuiDataGrid-cell": {
              padding: "0px 2px",
            },
            "& .MuiDataGrid-columnHeader": {
              whiteSpace: "normal",
              lineHeight: "1.2em",
              paddingTop: "8px",
              paddingBottom: "1px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              wordWrap: "break-word",
              fontSize: "11px", // Optional for better fit
            },
            "& .MuiDataGrid-columnHeaderTitleContainer": {
              textAlign: "center",
              justifyContent: "center",
            },
          }}
        />
      </Box>
      </div>
    </>
    
  );
};

export default StockSetupApprove;
